import { render, staticRenderFns } from "./newLeaveReason.vue?vue&type=template&id=032f6ca5&"
import script from "./newLeaveReason.vue?vue&type=script&lang=js&"
export * from "./newLeaveReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VForm,VRow,VSheet,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032f6ca5')) {
      api.createRecord('032f6ca5', component.options)
    } else {
      api.reload('032f6ca5', component.options)
    }
    module.hot.accept("./newLeaveReason.vue?vue&type=template&id=032f6ca5&", function () {
      api.rerender('032f6ca5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveReason/newLeaveReason.vue"
export default component.exports